import React from "react";
import "./Css/LeadersSection.css";
import leader3 from "./Images/madam.jpg"; 
import leader1 from "./Images/sarpanch.jpg";
import leader2 from "./Images/upsarpanch.jpg";

const LeadersSection = () => {
  const leaders = [
     {
      img: leader3,
      name: "श्रीमती. तृप्ती श्रीरंग जाधव",
      position: "ग्रामपंचायत अधिकारी ",
      description:
        "ग्रामपंचायतीच्या आर्थिक व्यवहारांचे नियोजन आणि निर्णयांची पारदर्शक अंमलबजावणी.",
    },
    {
      img: leader1,
      name: " सौ. कल्पना विठ्ठल मोहिते ",
      position: "सरपंच",
      description:
        "गावाच्या सर्वांगीण विकासाचे नेत्त्व करणे, ग्रामसभांमधील अध्यक्षपदाचे संचालन आणि लोकसहभागातून निर्णय घेणे.",
    },
    {
      img: leader2,
      name: "श्री. विजय अरुण गुरव ",
      position: "उपसरपंच",
      description:
        "सार्वजनिक प्रकल्पांतील सहकार्य, ग्रामविकासासाठी सरकारी योजनांचा लाभ नागरिकांपर्यंत पोहोचवणे.",
    },
   
  ];

  return (
    <section className="leaders-section">
      <h2 className="leaders-title">गावाच्या विकासाचे सूत्रधार</h2>
      <p className="leaders-subtitle">
गावाच्या सर्वांगीण विकासासाठी कार्यरत असलेले आणि प्रामाणिकपणे सेवा देणारे अधिकारी.      </p>

      <div className="leaders-container">
        {leaders.map((leader, index) => (
          <div key={index} className="leader-card">
            <img src={leader.img} alt={leader.name} className="leader-image" />
            <h3 className="leader-name">{leader.name}</h3>
            <p className="leader-position">पद : {leader.position}</p>
            <p className="leader-description">{leader.description}</p>
          </div>
        ))}
      </div>
    </section>
  );
};

export default LeadersSection;
